import React from 'react';
import { Icon } from '../Icon';
import nextImageSrc from '../../assets/images/slide/next-icon.png';
import styles from './UserMixSummarySlideV2.css';

function UserMixSummarySlideV2({
    description = <>To personalize your protection plan, tell us how you use them — this helps us understand <strong>your risk exposure</strong>.</>,
    nextStepText = 'Now, answer a few quick questions about your online activity.',
    results = {},
    prevQuestionId
}) {
    const numberOfAccounts = prevQuestionId
        ? (results.userResponses.find(r => r.questionId === prevQuestionId)?.answerIds?.length ?? 0)
        : 0;

    return (
        <div className={styles.root}>
            <div className={styles.iconWrapper}>
                <Icon name='shieldCheck' />
            </div>
            <h2 className={styles.title}>We've got you!</h2>
            <h3 className={styles.title}><strong>You selected {numberOfAccounts} {numberOfAccounts === 1 ? 'account' : 'accounts'} to manage.</strong></h3>
            <p className={styles.description}>{description}</p>
            <div className={styles.nextStepBlock}>
                <img src={nextImageSrc} alt='next' />
                <p>{nextStepText}</p>
            </div>
        </div>
    );
}

export {
    UserMixSummarySlideV2
};
